import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    getVouchersSuccess, getVouchersFailure,
    createVoucherSuccess, createVoucherFailure,
    updateVoucherSuccess, updateVoucherFailure,
    deleteVoucherSuccess, deleteVoucherFailure,
} from './slice';
import requestHandler from '../../../utils/requestHandler';
import { logoutRequest } from '../auth/authSlice';

const API_BASE = process.env.REACT_APP_SERVER_API;

function getAuthHeaders(branchId) {
    return {
        "Authorization": localStorage.getItem("item"),
        "Content-Type": "application/json",
        "X-Current-Branch": branchId,
    };
}

function* getVouchers(action) {
    try {
        const token = localStorage.getItem("item");
        if (!token) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const params = action.payload || {};
        const queryString = new URLSearchParams(params).toString();
        const response = yield call(requestHandler, `${API_BASE}api/vouchers?${queryString}`, {
            method: "GET",
            headers: getAuthHeaders(currentBranch.id),
        });
        yield put(getVouchersSuccess(response));
    } catch (error) {
        yield put(getVouchersFailure(error?.response?.message || error));
    }
}

function* createVoucher(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(requestHandler, `${API_BASE}api/vouchers`, {
            method: "POST",
            headers: getAuthHeaders(currentBranch.id),
            body: JSON.stringify(action.payload),
        });
        yield put(createVoucherSuccess(response));
    } catch (error) {
        yield put(createVoucherFailure(error?.response?.message || error));
    }
}

function* updateVoucher(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(requestHandler, `${API_BASE}api/vouchers`, {
            method: "PUT",
            headers: getAuthHeaders(currentBranch.id),
            body: JSON.stringify(action.payload),
        });
        yield put(updateVoucherSuccess(response));
    } catch (error) {
        yield put(updateVoucherFailure(error?.response?.message || error));
    }
}

function* deleteVoucher(action) {
    try {
        const currentBranch = yield select(state => state.branch.currentBranch);
        const response = yield call(requestHandler, `${API_BASE}api/vouchers/${action.payload}`, {
            method: "DELETE",
            headers: getAuthHeaders(currentBranch.id),
        });
        yield put(deleteVoucherSuccess(response));
    } catch (error) {
        yield put(deleteVoucherFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('voucher/getVouchersRequest', getVouchers);
    yield takeLatest('voucher/createVoucherRequest', createVoucher);
    yield takeLatest('voucher/updateVoucherRequest', updateVoucher);
    yield takeLatest('voucher/deleteVoucherRequest', deleteVoucher);
}

export default saga;
